import {
  GET_EMAILS_REQUEST,
  GET_EMAILS_REQUEST_SUCCESS,
  GET_EMAILS_REQUEST_FAILURE,
  PATCH_EMAILS_REQUEST,
  PATCH_EMAILS_REQUEST_SUCCESS,
  PATCH_EMAILS_REQUEST_FAILURE,
} from "./mutation-types";
import { RESET } from "../../mutation-types";
import { getDefaultState } from "./state";

const setBillingEmailsData = (state, payload) => {
  state.registrationEmail = payload.registrationEmail;
  state.regEmailBillingEnabled = payload.regEmailBillingEnabled;

  state.accountingEmail = payload.accountingEmail;
  state.accountingEmailEnabled = payload.accountingEmailEnabled;
};

const mutations = {
  [GET_EMAILS_REQUEST]: (state) => {
    state.isRequesting = true;
  },

  [GET_EMAILS_REQUEST_SUCCESS]: (state, payload) => {
    setBillingEmailsData(state, payload);

    state.isRequesting = false;
  },

  [GET_EMAILS_REQUEST_FAILURE]: (state) => {
    state.isRequesting = false;
  },

  [PATCH_EMAILS_REQUEST]: (state) => {
    state.isRequesting = true;
  },

  [PATCH_EMAILS_REQUEST_SUCCESS]: (state, payload) => {
    setBillingEmailsData(state, payload);

    state.isRequesting = false;
  },

  [PATCH_EMAILS_REQUEST_FAILURE]: (state) => {
    state.isRequesting = false;
  },

  [RESET]: (state) => {
    Object.assign(state, getDefaultState());
  },
};

export default mutations;
